import antdEnUS from "antd/es/locale/en_US";
import antdZhCn from "antd/es/locale/zh_CN";
import antdKoKR from "antd/es/locale/ko_KR";
import antdJaJP from "antd/es/locale/ja_JP";
import antdThTH from "antd/es/locale/th_TH";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { THEME_CONFIG } from "configs/AppConfig";

// 언어별 번역 파일 import
import en from "./locales/en.json";
import ko from "./locales/ko.json";
import ja from "./locales/ja.json";
import zhCN from "./locales/zh-CN.json";
import zhTW from "./locales/zh-TW.json";
import th from "./locales/th.json";

// 언어 리소스 설정
export const resources = {
  en: {
    translation: en,
    antd: antdEnUS,
  },
  "zh-Hans": {
    translation: zhCN,
    antd: antdZhCn,
  },
  "zh-Hant": {
    translation: zhTW,
    antd: antdZhCn,
  },
  ko: {
    translation: ko,
    antd: antdKoKR,
  },
  ja: {
    translation: ja,
    antd: antdJaJP,
  },
  th: {
    translation: th,
    antd: antdThTH,
  },
};

// i18n 초기화
i18n.use(initReactI18next).init({
  resources,
  fallbackLng: THEME_CONFIG.locale,
  lng: THEME_CONFIG.locale,
  interpolation: {
    escapeValue: false,
  },
});

/**
 * 언어별 번역 파일 관리 시스템
 * - 각 언어별로 독립적인 JSON 파일로 관리됩니다
 * - 번역 추가/수정은 src/lang/locales/ 디렉토리의 해당 언어 파일을 편집하면 됩니다
 * - 지원 언어: en, ko, ja, zh-CN (간체), zh-TW (번체), th
 */

export default i18n;
